<ng-template #template>
  <tui-preview
    [ngClass]="{cleanView: cleanView}"
    (tuiSwipe)="onSwipe($event)"
    (click)="click($event)"
    [class.isVideo]="isVideo()"
    >
    @if (title) {
      <tui-preview-title>
        {{ title }}
        @if (pictures?.length > 1) {
          / {{ index + 1 }}
        }
        @if (currentImage?.picture && showMeta) {
          <small>
            / {{ currentImage.picture.sizeX }}x{{ currentImage.picture.sizeY }} / {{ currentImage.picture.type }}
          </small>
        }
      </tui-preview-title>
    }

    @if (pictures.length > 1) {
      <tui-preview-pagination size="m"
        [length]="pictures.length"
        (indexChange)="onIndexChange($event)"
        [(index)]="index"
        />
    }

    <button
      tuiIconButton
      tuiPreviewAction
      style="cursor: none"
      size="m"
      (mouseenter)="setCleanView(true)"
      (mouseleave)="setCleanView(false)"
      >
      <tui-icon icon="eye"/>
    </button>
    <button
      tuiIconButton
      tuiPreviewAction
      size="m"
      iconStart="download"
      class="download"
      (click)="download()"
    ></button>
    @if (canExpand) {
      <button
        tuiIconButton
        tuiPreviewAction
        size="m"
        (click)="expand()"
        >
        <tui-icon icon="maximize-2" />
      </button>
    }
    @if (canCollapse) {
      <button
        tuiIconButton
        tuiPreviewAction
        size="m"
        (click)="collapse(false)"
        >
        <tui-icon icon="minimize-2" />
      </button>
    }
    <button
      tuiPreviewAction
      tuiIconButton
      size="m"
      iconStart="x"
      (click)="close()"
    ></button>

    @if (!isVideo()) {
      <div class="preview-media">
        @if (currentImage.original) {
          <lib-ngx-image-zoom
            magnification="1.5"
            [thumbImage]=currentImage.src
            [fullImage]=currentImage.original
            />
        } @else {
          <img [src]="currentImage.src" alt="" style="max-width: 100%; max-height: calc(100dvh - 170px); width: auto; height: auto; object-fit: contain;"/>
        }
      </div>
    }

    @if (currentImage.videoCode) {
      <div>
        <youtube-player class="player" [playerVars]="{autoplay: playerVars.autoplay}" [width]="playerVars.width" [height]="playerVars.height" [videoId]="currentImage.videoCode"/>
      </div>
    }

    @if (currentImage.videoLink) {
      <div>
        <iframe class="player" [src]="safeVideoUrl(currentImage.videoLink)" [width]="playerVars.width" [height]="playerVars.height" allowfullscreen frameborder="0"></iframe>
      </div>
    }

    @if (pictures?.length > 1) {
      <div class="thumb">
        @for (picture of pictures; track picture; let i = $index) {
          <span [class.selected-video]="isVideo(picture)" [class.active]="i === index">
            <img [src]="picture.src" draggable="false" alt="" (click)="select(i)"/>
            @if (isVideo(picture)) {
              <img alt="" class="video-icon" src="/assets/images/product/video.svg">
            }
          </span>
        }
      </div>
    }

    {{ done() }}

  </tui-preview>

</ng-template>
